module.exports = __webpack_public_path__ + "static/img/product3.97dc4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/red/product3.png
// module id = mrYG
// module chunks = 0